/**
 * Onboarding Module
 * 
 * Provides reusable components and utilities for user and admin onboarding flows.
 * 
 * @module onboarding
 */

// Types
export * from "./types";

// Data
export { USER_ONBOARDING_SLIDES, USER_ONBOARDING_BUTTON_TEXT } from "./data/userSlides";
export { 
  ADMIN_ONBOARDING_SLIDES, 
  ADMIN_ONBOARDING_BUTTON_TEXT,
  ADMIN_ROLE_NOTIFICATION_LOTTIE,
} from "./data/adminSlides";

// Hooks
export { useOnboarding } from "./hooks/useOnboarding";

// Components
export { OnboardingCarousel } from "./components/OnboardingCarousel";
export { OnboardingSlide } from "./components/OnboardingSlide";
export { OnboardingProgress } from "./components/OnboardingProgress";
export { CompleteProfileScreen } from "./components/CompleteProfileScreen";

